import { AxiosPromise } from "axios";
import { request } from "./request";
import {
  ActionMultiAttendantPayload,
  ActionSingleAttendantPayload,
  EditGroupPayload,
  MultiMoveAttendantPayload,
  SingleMoveAttendantPayload,
} from "../types";

export const groupApi = {
  findAll: (params?: Record<string, any>): AxiosPromise<any> =>
    request({
      url: `group-management/groups/page/${params?.page ?? 1}`,
      method: "get",
      params,
    }),

  events: (): AxiosPromise<any> =>
    request({
      url: `content/dropdown/events?uncheck=true&event_type=sports`,
      method: "get",
    }),

  detail: (id: string): AxiosPromise<any> =>
    request({
      url: `/group-management/groups/${id}/detail`,
      method: "get",
    }),

  getGroupAttendants: (
    id: string,
    params?: Record<string, any>
  ): AxiosPromise<any> =>
    request({
      url: `group-management/groups/${id}/attendants/page/${params?.page ?? 1}`,
      method: "get",
      params,
    }),

  getExportId: (params?: Record<string, any>): AxiosPromise<any> =>
    request({
      url: `export/groups`,
      method: "get",
      params,
    }),

  getAttendantsExportId: (params?: Record<string, any>): AxiosPromise<any> =>
    request({
      url: `export/group-attendants`,
      method: "get",
      params,
    }),

  getExportResult: (id: string): AxiosPromise<any> =>
    request({
      url: `export/result/${id}`,
      method: "get",
    }),

  update: (data: EditGroupPayload): AxiosPromise<any> =>
    request({
      url: `/group-management/groups`,
      method: "post",
      data: data,
      headers: {
        "Content-Type": "application/json",
      },
    }),

  actionSingleMember: (
    group_id: string,
    data: ActionSingleAttendantPayload
  ): AxiosPromise<any> =>
    request({
      url: `/group-management/groups/${group_id}/action-member`,
      method: "post",
      data: data,
      headers: {
        "Content-Type": "application/json",
      },
    }),

  actionMultiMember: (
    group_id: string,
    data: ActionMultiAttendantPayload
  ): AxiosPromise<any> =>
    request({
      url: `/group-management/groups/${group_id}/bulk-action-member`,
      method: "post",
      data: data,
      headers: {
        "Content-Type": "application/json",
      },
    }),

  // Use for Select component
  getAllGroups: (
    event_id: string,
    params?: Record<string, any>
  ): AxiosPromise<any> =>
    request({
      url: `group-management/events/${event_id}/groups`,
      method: "get",
      params,
    }),

  moveSingleMember: (
    source_group_id: string,
    data: SingleMoveAttendantPayload
  ): AxiosPromise<any> =>
    request({
      url: `/group-management/groups/${source_group_id}/move-participant`,
      method: "post",
      data: data,
      headers: {
        "Content-Type": "application/json",
      },
    }),

  moveMultiMember: (
    source_group_id: string,
    data: MultiMoveAttendantPayload
  ): AxiosPromise<any> =>
    request({
      url: `/group-management/groups/${source_group_id}/bulk-move-participant`,
      method: "post",
      data: data,
      headers: {
        "Content-Type": "application/json",
      },
    }),

  detailAttendant: (attendant_id: string): AxiosPromise<any> =>
    request({
      url: `/group-management/groups/attendants/${attendant_id}/detail`,
      method: "get",
    }),

  importAttendantData: (
    group_id: string,
    data: {
      pwd_group: string;
      attendants: Record<string, string>[];
    }
  ): AxiosPromise<any> =>
    request({
      url: `/group-management/groups/${group_id}/import`,
      method: "post",
      data: data,
      headers: {
        "Content-Type": "application/json",
      },
    }),

  getAttendantTemplate: (): AxiosPromise<any> =>
    request({
      url: `/group-management/manager/attributes`,
      method: "get",
    }),

  getGroupHistory: (
    group_id: string,
    params?: Record<string, any>
  ): AxiosPromise<any> =>
    request({
      url: `/group-management/groups/${group_id}/activity-history/page/${
        params?.page ?? 1
      }`,
      method: "get",
      params,
    }),

  updateDiscount: (group_id: string): AxiosPromise<any> =>
    request({
      url: `/group-management/groups/${group_id}/compute-discount`,
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
    }),
};
